import { getProgressTrackerItemState, ProgressTracker, ProgressTrackerItem } from "@octopusdeploy/design-system-components";
import React from "react";
interface ConfigWizardStatusProps {
    activeStage: ConfigWizardStages;
    isCommittingRunbooksToNewBranch: boolean;
}
type ConfigWizardStages = "Environment" | "Auto Deploy" | "Naming" | "Provisioning" | "Deprovisioning" | "Branch";
export const ConfigWizardStatusBar = ({ activeStage, isCommittingRunbooksToNewBranch }: ConfigWizardStatusProps): JSX.Element | null => {
    const stages: ConfigWizardStages[] = ["Environment", "Auto Deploy", "Provisioning", "Deprovisioning"];
    if (isCommittingRunbooksToNewBranch) {
        stages.push("Branch");
    }
    const indexOfActiveStage = stages.indexOf(activeStage);
    return (<ProgressTracker>
            {stages.map((stage, index) => {
            return <ProgressTrackerItem label={stage} state={getProgressTrackerItemState(index, indexOfActiveStage)} layout={isCommittingRunbooksToNewBranch ? "compact" : "normal"}/>;
        })}
        </ProgressTracker>);
};
